import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  EditarPreguntaFrecuenteDTO,
  FiltroPreguntaDTO,
  PreguntaFrecuenteDTO,
} from '../../dto/preguntas-frecuentes/pregunta-frecuenteDTO';

@Injectable({
  providedIn: 'root',
})
export class PreguntasFrecuentesService {
  private apiUrl = `${environment.apiUrl}/preguntasfrecuentes`;
  constructor(private http: HttpClient) { }

  listarPreguntas(filtro: FiltroPreguntaDTO) {
    return this.http.post<PreguntaFrecuenteDTO[]>(
      `${this.apiUrl}/consultar`,
      filtro
    );
  }

  modificarPregunta(preguntaId: number, data: EditarPreguntaFrecuenteDTO) {
    return this.http.patch(`${this.apiUrl}/${preguntaId}`, data);
  }

  crearPregunta(data: EditarPreguntaFrecuenteDTO) {
    return this.http.post(`${this.apiUrl}/guardar`, data);
  }

  editarEstadoPregunta(idPregunta:number) {
    const params = new HttpParams().set('id', idPregunta.toString());

    return this.http.post<void>(
      `${this.apiUrl}/cambioEstado/`,
      null,
      { params }
    );
  }
}
